export default {"src":"/_next/static/media/fr-CA.987bf3c9.svg","height":26,"width":32,"blurWidth":0,"blurHeight":0};